import React from 'react';
import img2 from '../../assets/images/others/ladder01.png';
import img1 from '../../assets/images/png_pic/tiltable-4.png';
import img3 from '../../assets/images/others/ladder9 (1).png';
import img4 from '../../assets/images/others/grid6.png';
import img5 from '../../assets/images/others/about-ladder3.png';
import { Link } from 'react-router-dom';

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const Herosection = () => {
  return (
   
      <section className="relative">
        <div className=" mx-auto flex h-auto w-full max-w-[100vw] overflow-hidden transition-all">
          <div className="relative z-10 mx-auto h-full min-w-[100vw] overflow-hidden bg-gray-50">
            <div className="container mx-auto" data-aos="zoom-out-up">
              <div className="flex flex-wrap items-center">
                {/* Text Section */}
                <div className="w-full px-4 lg:w-1/2">
                  <div className="mt-5 max-w-[570px] md:mt-8 lg:mt-10">
                    
                    <h2 className="mb-[18px] capitalize text-2xl font-bold leading-tight xl:text-4xl sm:text-3xl md:text-3xl">
                    Rising to New Heights of Safety and Durability
                    </h2>
                    <p className="mb-9 text-sm md:text-base">
                    At Yogesh Aluminium Ladder Manufacturing Company, we craft ladders that elevate your work with unwavering strength and reliability. Trusted by professionals, built for safety.
                    </p>

                    <Link to={'/contact'} >
                    <button
                    
                      className="inline-flex items-center justify-center rounded-full bg-[#182e55] px-5 md:px-7 py-[13px] text-center text-sm md:text-base font-medium text-white hover:bg-[#234279]"
                    >
                      Connect Now
                    </button>
                    </Link>
                  </div>
                </div>

                {/* Image Section */}
                <div className="w-full px-4 lg:w-1/2 mt-8 lg:mt-0">
                  <div className="text-center">
                  <Swiper
                      modules={[Autoplay, Pagination]}
                      autoplay={{
                        delay: 3000, // Time delay between slides (in ms)
                        disableOnInteraction: false, // Keeps autoplay active after user interaction
                      }}
                      // pagination={{ clickable: true }}
                      loop={true} // Makes the slider loop infinitely
                      className="h-full "
                    >
                      <SwiperSlide>
                        <div className="swiper-slide relative ">
                          <img
                            src={img1}
                            className="h-[300px] md:h-[600px] xl:[600px] w-full "
                          />
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="swiper-slide relative ">
                          <img
                            src={img2}
                            className="h-[300px] md:h-[600px] xl:[600px] w-full "
                          />
                        </div>
                      </SwiperSlide>
                      <SwiperSlide>
                        <div className="swiper-slide relative ">
                          <img
                            src={img3}
                            className="h-[300px] md:h-[600px] xl:[600px] w-full "
                          />
                        </div>
                      </SwiperSlide>

                      <SwiperSlide>
                        <div className="swiper-slide relative ">
                          <img
                            src={img4}
                            className="h-[300px] md:h-[600px] xl:[600px] w-full "
                          />
                        </div>
                      </SwiperSlide>

                      <SwiperSlide>
                        <div className="swiper-slide relative ">
                          <img
                            src={img5}
                            className="h-[300px] md:h-[600px] xl:[600px] w-full "
                          />
                        </div>
                      </SwiperSlide>
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>

            {/* Background SVG - Left */}
            <div className="absolute left-0 top-0 -z-10 rotate-180">
              <svg width="620" height="560" viewBox="0 0 620 560" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 560L256.5 0H620V560H0Z"
                  fill="url(#paint0_linear_2066_370)"
                ></path>
                <defs>
                  <linearGradient
                    id="paint0_linear_2066_370"
                    x1="100.001"
                    y1="280"
                    x2="535.002"
                    y2="280"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#3056D3" stopOpacity="0.08"></stop>
                    <stop offset="1" stopColor="#3056D3" stopOpacity="0"></stop>
                  </linearGradient>
                </defs>
              </svg>
            </div>

            {/* Background SVG - Right */}
            <div className="absolute right-0 bottom-0 -z-10 rotate-45">
              <svg
                width="536"
                height="560"
                viewBox="0 0 536 560"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.998535 560L257.499 0H535.999V560H0.998535Z"
                  fill="url(#paint0_linear_2066_368)"
                ></path>
                <defs>
                  <linearGradient
                    id="paint0_linear_2066_368"
                    x1="101"
                    y1="280"
                    x2="536"
                    y2="280"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#3056D3" stopOpacity="0.08"></stop>
                    <stop offset="1" stopColor="#3056D3" stopOpacity="0"></stop>
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </section>
    
  );
};

export default Herosection;
